import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
                <i className="ri-film-line text-primary-950 text-xl" />
              </span>
              <span className="font-display text-xl font-extrabold text-background-50">久久热</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80 max-w-xs">
              久久热是一个综合影视内容平台，汇聚最新电影、热门电视剧与综艺的资讯和推荐，帮你更快发现值得一看的好作品。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-tv-2-line', 'ri-mail-line'].map((icon) => (
                <span key={icon} className="w-9 h-9 rounded-md bg-primary-900 flex items-center justify-center text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer">
                  <i className={`${icon} text-lg`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 tracking-wide">影视分类</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: '电影', to: '/category/movie' },
                { label: '电视剧', to: '/category/tv' },
                { label: '综艺', to: '/category/variety' },
                { label: '站内搜索', to: '/search' },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 tracking-wide">精选专题</h3>
            <ul className="mt-4 space-y-2.5">
              {topics.map((t) => (
                <li key={t.id}>
                  <Link to={`/topic/${t.id}`} className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                    {t.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 tracking-wide">关于久久热</h3>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-sm text-background-200/80 hover:text-accent-400 transition-colors cursor-pointer">意见反馈</Link></li>
              <li><span className="text-sm text-background-200/80">内容合作：hello@jiujiure.example.com</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">© 2026 久久热 综合影视内容平台 · 本站内容为演示数据，仅供浏览参考</p>
          <p className="text-xs text-background-200/60">不提供在线播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}